enum AccountingActions {
    // Dokumente (invoice/offer/credit) //
    FETCH_LIST = "accountingFetchList",
    REFRESH_LIST = "accountingRefreshList",
    GET_ITEM = "accountingGetItem",
    CREATE_ITEM = "accountingCreateItem",
    UPDATE_ITEM = "accountingUpdateItem",
    DELETE_ITEM = "accountingDeleteItem",
    SET_STATE = "accountingSetState",
    SET_PAID = "accountingSetPaid",
    CONVERT = "accountingConvert",
    FETCH_FORM_DATA = "accountingFetchFormData",
    PRINT_DOCUMENT = "accountingPrintDocument",
    SEARCH_RECIPIENTS = "accountingSearchRecipients",
    // Produkte (Positionen-Vorlagen) //
    FETCH_PRODUCTS = "accountingFetchProducts",
    GET_PRODUCT = "accountingGetProduct",
    CREATE_PRODUCT = "accountingCreateProduct",
    UPDATE_PRODUCT = "accountingUpdateProduct",
    DELETE_PRODUCT = "accountingDeleteProduct",
    // Settings + Nummernkreise //
    FETCH_SETTINGS = "accountingFetchSettings",
    UPDATE_SETTINGS = "accountingUpdateSettings",
}

enum AccountingMutation {
    SET_RENDER_UPDATE = "accountingListRenderNeeded",
    SET_LIST_RESULT = "accountingListResult",
    SET_FORM_DATA = "accountingSetFormData",
}

export {AccountingActions, AccountingMutation};
